module.exports = __webpack_public_path__ + "static/media/img7.9350f702.svg";